import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../Button';
import { HeaderProps } from '../../../types';

const Header: React.FC<HeaderProps> = ({ className = '' }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: 'Home', href: '/' },
    { label: 'Features', href: '/features' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'Contact', href: '/contact' }
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''} ${className}`}>
      <div className="header__container">
        <Link to="/" className="header__logo" onClick={closeMobileMenu}>
          <img src="/InferiumTitle.png" alt="Inferium Reports" />
        </Link>

        <nav className="header__nav">
          {navItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={`header__nav-link ${
                location.pathname === item.href ? 'header__nav-link--active' : ''
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="header__cta">
          <Button
            variant="outline"
            size="sm"
            href="https://login.inferiumreports.com"
            target="_blank"
            className="hide-mobile"
          >
            Client Login
          </Button>
          <Button
            variant="primary"
            size="sm"
            href="/pricing"
          >
            Get Started
          </Button>
        </div>

        <button
          className="header__mobile-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            {isMobileMenuOpen ? (
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            ) : (
              <path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            )}
          </svg>
        </button>
      </div>

      <div className={`header__mobile-menu ${isMobileMenuOpen ? 'header__mobile-menu--open' : ''}`}>
        <nav className="header__mobile-nav">
          {navItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className="header__mobile-nav-link"
              onClick={closeMobileMenu}
            >
              {item.label}
            </Link>
          ))}
          <Link
            to="https://login.inferiumreports.com"
            className="header__mobile-nav-link"
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeMobileMenu}
          >
            Client Login
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
